<template>
  <div :class="$style.topbar">
    <div :class="$style.topbarLeft">
      <!-- <p class="btn btn-5">Get 50% OFF 1 Year NOW</p> -->
    </div>
    <div :class="$style.topbarRight">
      <div>
        <cui-user-menu />
      </div>
      <div style="margin-right: 10px">
        <button v-if="creator.changes" @click="saveState" class="btn btn-sales">SAVE</button>
      </div>
    </div>
  </div>
</template>

<script>
import CuiUserMenu from './UserMenu'
import { mapState } from 'vuex'

export default {
  components: {
    CuiUserMenu,
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    ...mapState(['creator']),
  },
  methods: {
    saveState() {
      this.$store.dispatch('creator/saveState')
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
